// https://en.wikipedia.org/wiki/Point_in_polygon
//http://www.cnblogs.com/luxiaoxun/p/3722358.html
const PI = Math.PI;
const EARTH_RADIUS = 6378137.0;
const toRad = PI / 180;
const toDeg = 180 / PI;

/**
 * 计算from到to的航向
 */
const heading = (from, to) => {
  let e = from.lat * toRad,
    f = to.lat * toRad,
    g = to.lng * toRad - from.lng * toRad;
  let r = (Math.atan2(Math.sin(g) * Math.cos(f), Math.cos(e) * Math.sin(f) - Math.sin(e) * Math.cos(f) * Math.cos(g))) * toDeg;

  if (r < 0) r += 360;

  return r;
}

/**
 * 根据当前位置、距离和方位角 计算另一个点
 * @param from 开始位置
 * @param dist 距离
 * @param azimuth 方位角
 * @param radius 球半径，默认为地球半径
 * @returns {{lat: number, lng: number}}
 */
const offset = (from, dist, azimuth, radius) => {
  let heading = azimuth * toRad;
  let lat1 = from.lat * toRad;
  let lng1 = from.lng * toRad;
  let dByR = dist / (radius || EARTH_RADIUS);
  let lat = Math.asin(
    Math.sin(lat1) * Math.cos(dByR) +
    Math.cos(lat1) * Math.sin(dByR) * Math.cos(heading));
  let lng = lng1 + Math.atan2(
    Math.sin(heading) * Math.sin(dByR) * Math.cos(lat1),
    Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
  return { lat: lat * toDeg, lng: lng * toDeg };
}

/**
 * 求两点间距离
 * @param p1
 * @param p2
 * @returns {number}
 */
const distance = (p1, p2) => {

  let lat1 = p1.lat,
    lng1 = p1.lng,
    lat2 = p2.lat,
    lng2 = p2.lng;
  lat1 = lat1 * toRad;
  lat2 = lat2 * toRad;

  let a = lat1 - lat2;
  let b = lng1 * toRad - lng2 * toRad;

  let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(b / 2), 2)));
  s = s * EARTH_RADIUS;
  s = Math.round(s * 10000) / 10000.0;
  return s;
}

//从集合中获取最近点的序号
const nearest = (p , points) => {
  let min_dis = Infinity , idx = 0
  points.forEach( (i , index) => {
    let d = distance(p , i)
    if(d < min_dis){
      min_dis = d
      idx = index
    }
  })
  return idx
}

export default { heading , offset, distance , nearest }